export default {
    setCruzados(state, c) {
        state.cruzados = c;
    }
}